export default __webpack_public_path__ + "static/ThecruciallegacymissingfromUSfood-160d3eb53116e143695c314afa2c6269.jpg";